<template>
  <div
    ref="leafletViewer"
    class="leaflet-viewer-container disable-zoom-on-safari  mt-1"
    style="position:relative;"
  >
    <swiper
      :options="swiperOptions"
      @slideChange="slideChanged"
      ref="swiper"
      :class="{ fullscreen: fullscreen }"
      :style="[
        { maxWidth: fullscreen ? '' : swiperHeight },
        !$vuetify.breakpoint.smAndDown ? { padding: '0px 0px 40px' } : {}
      ]"
    >
      <swiper-slide
        v-for="page in leaflet.leafletPage"
        :key="page.leafletPageId"
      >
        <div class="leaflet-page-container">
          <div
            class="imgage-container"
            :style="{
              maxHeight: swiperHeight,
              height: fullscreen ? swiperHeight : 'auto'
            }"
          >
            <div
              class="swiper-zoom-container"
              :style="{
                maxHeight: fullscreen ? 'auto' : swiperHeight
              }"
            >
              <v-img
                class="image"
                contain
                @onerror="
                  this.onerror = null;
                  this.src = '/no-icon.png';
                "
                :src="`${leaflet.baseLocation}${page.imageLocation}`"
              />

              <div
                :id="`leaflet-area-${area.leafletAreaId}`"
                v-for="area in page.leafletArea"
                :key="area.leafletAreaId"
                :class="
                  (area.products && area.products.length > 0) ||
                  (area.metadata && area.metadata.leafletareatype_product) ||
                  (area.metadata && area.metadata.leafletareatype_cta)
                    ? 'draggable'
                    : ''
                "
                @click.stop="
                  openDetail(
                    area.leafletAreaId,
                    area.leafletAreaTypeId,
                    area.metadata,
                    area.metadata &&
                      area.metadata.leafletareatype_product &&
                      area.metadata.leafletareatype_product.ICON_TYPE,
                    area.link
                  )
                "
                :style="{
                  left: area.x + '%',
                  top: area.y + '%',
                  width: area.w + '%',
                  height: area.h + '%',
                  fontSize: '10px'
                }"
              >
                <v-icon
                  @click.stop="
                    openDetail(
                      area.leafletAreaId,
                      area.leafletAreaTypeId,
                      area.metadata,
                      area.metadata &&
                        area.metadata.leafletareatype_product &&
                        area.metadata.leafletareatype_product.ICON_TYPE,
                      area.link
                    )
                  "
                  v-if="
                    area.metadata &&
                      area.metadata.leafletareatype_product &&
                      area.metadata.leafletareatype_product.ICON_TYPE &&
                      area.metadata.leafletareatype_product.ICON_TYPE !=
                        'cta' &&
                      area.metadata.leafletareatype_product.ICON_TYPE != 'bulb'
                  "
                  small
                  color="white"
                  class="leaflet-icon pulse secondary"
                  :class="area.metadata.leafletareatype_product.ICON_POSITION"
                >
                  icon-{{ area.metadata.leafletareatype_product.ICON_TYPE }}
                </v-icon>
                <img
                  v-else-if="
                    area.metadata?.leafletareatype_product?.ICON_TYPE === 'bulb'
                  "
                  class="leaflet-icon pulse secondary"
                  :class="area.metadata.leafletareatype_product.ICON_POSITION"
                  src="/img/info 2.svg"
                />
                <v-btn
                  class="leaflet-button pulse white--text text-uppercase"
                  outlined
                  depressed
                  v-else-if="
                    area.metadata &&
                      area.metadata.leafletareatype_product &&
                      area.metadata.leafletareatype_product &&
                      area.metadata.leafletareatype_product.ICON_TYPE &&
                      area.metadata.leafletareatype_product.ICON_TYPE === 'cta'
                  "
                  :class="[
                    area.metadata.leafletareatype_product.ICON_POSITION,
                    area.metadata.leafletareatype_product.COLOR
                  ]"
                  :click="clicked"
                  :href="area.link"
                  >{{ area.metadata.leafletareatype_product.LABEL }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div :class="{ 'hide-swiper-navigation': fullscreen }">
      <div :id="`leaflet-button-next-${fullscreen}`" class="swiper-button-next">
        <v-icon medium>mdi-chevron-right</v-icon>
      </div>
      <div :id="`leaflet-button-prev-${fullscreen}`" class="swiper-button-prev">
        <v-icon medium>mdi-chevron-left</v-icon>
      </div>
      <div
        :id="`swiper-pagination-${fullscreen}`"
        class="swiper-pagination"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>
<style lang="scss">
.leaflet-viewer-container {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    position: relative;
    z-index: 8;
  }
}
.disable-zoom-on-safari {
  touch-action: pan-y; /* Enable horizontal and vertical panning */
}
.hide-swiper-navigation {
  display: none;
}

.fullscreen {
  .draggable {
    display: none;
  }
}
.fullscreen {
  .leaflet-container {
    .swiper-slide img {
      height: 100%;
    }
  }
}
.leaflet-container {
  .leaflet-icon {
    // IL DEFAULT E' CE_CE
    width: 18px;
    height: 18px;
    opacity: 0.5;
    position: absolute;
    top: 40%;
    @media #{map-get($display-breakpoints, 'sm-only')} {
      top: 45%;
    }
    transform: translateY(-50%);
    left: 50%;
    transform: translateX(-50%);

    padding: 6px;
    border: 2px solid white;
    border-radius: 50%;
    // background-color: var(--v-primary-base);
    &.icon-play {
      padding: 6px 6px 6px 7px;
    }
    &::before {
      font-size: 12px;
    }
    // box-shadow: 3px 3px 5px 0px #000000;
    &.up_sx {
      left: 15%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 10%;
      }
      transform: translateX(-50%);
      top: 0%;
    }
    &.up_dx {
      left: 85%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 90%;
      }
      transform: translateX(-50%);
      top: 0%;
    }
    &.up_ce {
      left: 50%;
      transform: translateX(-50%);
      top: 0%;
    }
    &.lo_sx {
      left: 15%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 10%;
      }
      transform: translateX(-50%);
      top: 75%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 85%;
      }
    }
    &.lo_dx {
      left: 85%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 90%;
      }
      transform: translateX(-50%);
      top: 75%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 85%;
      }
    }
    &.lo_ce {
      left: 50%;
      transform: translateX(-50%);
      top: 75%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 85%;
      }
    }
    &.ce_sx {
      left: 15%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 10%;
      }
      transform: translateX(-50%);
      top: 40%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 45%;
      }
    }
    &.ce_dx {
      left: 85%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 90%;
      }
      transform: translateX(-50%);
      top: 40%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 45%;
      }
    }
    &.ce_ce {
      left: 50%;
      top: 40%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 45%;
      }
      transform: translateX(-50%);
    }
  }

  .leaflet-button {
    color: #fff;
    font-size: 9px;
    width: 64px;
    height: 36px;
    white-space: normal;
    display: flex;
    flex-direction: column;
    // opacity: 0.5;

    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 50%;
    transform: translateX(-50%);
    &.up_sx {
      left: 15%;
      transform: translateX(-50%);
      top: 0%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 10%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        left: 15%;
      }
    }
    &.up_dx {
      left: 85%;
      transform: translateX(-50%);
      top: 0%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        left: 90%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        left: 85%;
      }
    }
    &.up_ce {
      left: 50%;
      transform: translateX(-50%);
      top: 0%;
    }
    &.lo_sx {
      left: 15%;
      transform: translateX(-50%);
      top: 50%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 85%;
        left: 10%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        top: 70%;
        left: 15%;
      }
    }
    &.lo_dx {
      left: 85%;
      transform: translateX(-50%);
      top: 50%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 85%;
        left: 90%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        top: 70%;
        left: 85%;
      }
    }
    &.lo_ce {
      left: 50%;
      transform: translateX(-50%);
      top: 50%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 85%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        top: 70%;
      }
    }
    &.ce_sx {
      left: 15%;
      transform: translateX(-50%);
      top: 35%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 38%;
        left: 10%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        top: 25%;
        left: 15%;
      }
    }
    &.ce_dx {
      left: 85%;
      transform: translateX(-50%);
      top: 25%;
      @media #{map-get($display-breakpoints, 'sm-only')} {
        top: 38%;
        left: 90%;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        top: 25%;
        left: 85%;
      }
    }
    &.ce_ce {
      left: 50%;
      top: 38%;
      transform: translateX(-50%);
      // @media #{map-get($display-breakpoints, 'sm-and-down')} {
      //   top: 38%;
      // }
    }
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: lightgray;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .swiper-slide-active {
    -webkit-box-pack: flex-end;
    -ms-flex-pack: flex-end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    -webkit-box-align: flex-end;
    -ms-flex-align: flex-end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
  }
  .swiper-slide-next {
    -webkit-box-pack: flex-start;
    -ms-flex-pack: flex-start;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
  }

  .swiper-slide img {
    display: block;
    max-width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media only screen and (min-width: 769px) {
    .swiper-slide:first-child {
      transition: transform 100ms;
    }

    .swiper-slide:first-child img {
      transition: box-shadow 500ms;
    }

    .swiper-slide.swiper-slide-active:first-child {
      transform: translateX(50%);
      z-index: 2;
    }

    .swiper-slide.swiper-slide-active:first-child img {
      box-shadow: 0px 32px 80px rgba(0, 0, 0, 0.35);
    }

    .swiper-slide:nth-child(2) {
      transition: transform 100ms;
    }

    .swiper-slide.swiper-slide-next:nth-child(2) {
      transform: translateX(55%);
      z-index: 1;
    }

    .swiper[dir="rtl"] .swiper-slide.swiper-slide-active:first-child {
      transform: translateX(-50%);
    }

    .swiper[dir="rtl"] .swiper-slide.swiper-slide-next:nth-child(2) {
      transform: translateX(-55%);
    }

    /* 1. Force the Left Page (Active) to align to the right edge */
    .swiper-slide.swiper-slide-active .image .v-image__image,
    .swiper-slide.swiper-slide-active img {
      background-position: right center !important;
      object-position: right center !important;
    }

    /* 2. Force the Right Page (Next) to align to the left edge */
    .swiper-slide.swiper-slide-next .image .v-image__image,
    .swiper-slide.swiper-slide-next img {
      background-position: left center !important;
      object-position: left center !important;
    }
  }

  .category-leaflet-btn {
    .v-btn__content {
      flex-direction: column;
      .category-block-title {
        font-size: 10px;
        font-weight: normal;
        text-transform: none;
        white-space: initial;
        max-width: 70px;
      }
    }
  }
  .leaflet-page-container {
    position: relative;
    display: inline-block;
    max-height: 100%;
    max-width: 100%;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "" !important;
  }

  .draggable {
    cursor: pointer;
    position: absolute;
    background-color: transparent;
    // background-color: rgba(255, 221, 2, 0.35);
    border: 1px solid transparent;
    &:hover {
      background-color: rgba(255, 255, 255, 0.4);
      transition: all 0.3s;
      .leaflet-icon {
        opacity: 1;
      }
    }
  }

  .image {
    max-width: 100%;
    max-height: 100%;
    // height: 100%;
  }
  .swiper-pagination {
    position: absolute;
    bottom: 3px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    z-index: 5 !important;
    // top: 94% !important;
    background-color: #cacaca;
    font-size: 33px;
    width: 30px;
    i {
      color: #fff !important;
    }
    .mdi:before {
      font-size: 40px;
    }
  }
}
@media screen and (min-width: 960px) {
  .leaflet-container {
    .leaflet-icon {
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.pulse {
  animation: pulse 2s infinite;
}
.pulse:hover {
  animation: none;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 221, 2, 0.8);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
.fade_in_out {
  animation: fadeinout;
  animation-duration: 0s;
  animation-duration: 3s;
}
@keyframes fadeinout {
  from {
    background-color: rgba(255, 221, 2, 1);
    opacity: 0.6;
  }
  50% {
    opacity: 0.3;
  }
  to {
    opacity: 0.6;
  }
}
.leaflet-pagination {
  color: #000 !important;
}
.swiper-pagination-custom {
  padding: 16px;
}
</style>
<script>
import clickHandler from "~/mixins/clickHandler";
export default {
  name: "LeafletViewer",
  mixins: [clickHandler],
  props: {
    leaflet: { type: Object, required: true },
    fullscreen: { type: Boolean, default: false },
    swiperHeight: { type: String, default: "auto" },
    zoom: { type: Boolean, default: false },
    activeIndex: { type: Number, default: 0 }
  },
  data() {
    return {
      swiperOptions: {
        observer: true,
        observeParents: true,
        lazy: true,
        slidesPerView: 1,
        allowTouchMove: true,
        zoom: false,
        centeredSlides: false,
        slidesPerGroupSkip: 1,
        grabCursor: true,
        maxRatio: 5,
        keyboard: { enabled: true },
        breakpoints: {
          769: {
            slidesPerView: this.fullscreen ? 1 : 2,
            slidesPerGroup: this.fullscreen ? 1 : 2,
            pagination: {
              el: `#swiper-pagination-${this.fullscreen}`,
              type: "custom",
              renderCustom: function(swiper) {
                const activeIndex = swiper.activeIndex + 1;
                const nextIndex = activeIndex == 1 ? null : activeIndex + 1;
                return (
                  "<span class='pagination-value leaflet-pagination'>Pagina " +
                  activeIndex +
                  (nextIndex ? ", " + nextIndex : "") +
                  " di " +
                  swiper.slides.length +
                  "</span>"
                );
              }
            }
          }
        },
        pagination: {
          el: `#swiper-pagination-${this.fullscreen}`,
          type: "custom",
          renderCustom: function(swiper, current, total) {
            return "pagina " + current + " di " + total;
          }
        },
        navigation: {
          nextEl: `#leaflet-button-next-${this.fullscreen}`,
          prevEl: `#leaflet-button-prev-${this.fullscreen}`
        }
      },
      URLpage: null,
      foundArea: null
    };
  },
  methods: {
    openDetail(leafletAreaId, leafletAreaTypeId, metadata, iconType, link) {
      this.$emit("openDetail", {
        leafletAreaId,
        leafletAreaTypeId,
        metadata,
        iconType,
        link
      });
    },
    slideChanged() {
      const swiper = this.$refs.swiper.$swiper;
      const currentPage = swiper.activeIndex + 1;
      if (Number(this.$route.query.page) !== currentPage) {
        this.$router.replace({
          query: { ...this.$route.query, page: currentPage }
        });
      }
      this.$emit("slideChanged", swiper.activeIndex);
    },
    preventZoom(event) {
      if (event.ctrlKey) event.preventDefault();
    }
  },
  watch: {
    fullscreen(value) {
      this.$nextTick(() => {
        const swiper = this.$refs.swiper.$swiper;
        if (value) {
          swiper.zoom.enable();
          swiper.mousewheel.enable();
        } else {
          swiper.zoom.disable();
          swiper.mousewheel.disable();
          swiper.zoom.out();
        }
      });
    },
    "$route.query.page"(newVal) {
      const swiper = this.$refs.swiper?.$swiper;
      if (!swiper) return;
      const targetIndex = Number(newVal) - 1;
      if (targetIndex >= 0 && swiper.activeIndex !== targetIndex) {
        swiper.slideTo(targetIndex);
      }
    },
    leaflet: {
      immediate: true,
      handler(val) {
        if (!val) return;
        const entityAreaId = Number(
          this.$route.params.entity_area || this.$route.query.entity_area
        );
        if (!entityAreaId) return;
        let foundArea = null;
        for (const page of val.leafletPage || []) {
          foundArea = (page.leafletArea || []).find(
            area => area.leafletAreaId === entityAreaId
          );
          if (foundArea) break;
        }
        this.openDetail(
          foundArea && foundArea.leafletAreaId,
          foundArea && foundArea.leafletAreaTypeId,
          foundArea && foundArea.metadata,
          foundArea &&
            foundArea.metadata &&
            foundArea.metadata.leafletareatype_product &&
            foundArea.metadata.leafletareatype_product.ICON_TYPE,
          foundArea && foundArea.link
        );
      }
    }
  },
  mounted() {
    const swiper = this.$refs.swiper.$swiper;
    const page = Number(this.$route.query.page) || this.activeIndex + 1;
    // Hidden feature: Uncomment to enable for client approval and testing - related to RP-729
    // const showInfo = this.$route.query.show_info;
    // if (showInfo) {
    //   global.EventBus.$emit("showLeafletInfo");
    // }
    swiper.slideTo(page - 1);
    this.zoom ? swiper.zoom.enable() : swiper.zoom.disable();

    [
      "touchstart",
      "gesturestart",
      "gesturechange",
      "gestureend",
      "touchend",
      "wheel"
    ].forEach(evt => {
      window.addEventListener(evt, this.preventZoom, { passive: false });
    });
  },
  beforeDestroy() {
    [
      "touchstart",
      "gesturestart",
      "gesturechange",
      "gestureend",
      "touchend",
      "wheel"
    ].forEach(evt => {
      window.removeEventListener(evt, this.preventZoom);
    });
  }
};
</script>
